<div id="theUserForm" >
    <span *ngIf="title" class="mat-title">{{title}}</span>
    <div *ngIf="user" class="content pb-0 m-0" fusePerfectScrollbar>

        <form [formGroup]="contactForm">

            <div class="flex flex-row items-center justify-center">
                <mat-form-field dense appearance="outline" floatLabel="always" class="flex-grow">
                    <mat-label>Nombre y Apellido</mat-label>
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    <input name="name" formControlName="name" matInput required>
                </mat-form-field>
                <mat-form-field dense appearance="outline" class="flex-[0_0_20%]">
                    <mat-label>Iniciales</mat-label>
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    <input name="initials" formControlName="initials" matInput>
                </mat-form-field>
                <div class="flex-[0_0_20%] flex items-center">
                    <mat-checkbox formControlName="enabled" >Habilitado</mat-checkbox>
                </div>
            </div>


            <div class="flex flex-row items-start">
                <mat-form-field dense appearance="outline" class="flex-[0_0_34%]">
                    <mat-label>Usuario</mat-label>
                    <mat-icon matSuffix class="secondary-text">person</mat-icon>
                    <input name="login" formControlName="login" matInput >
                </mat-form-field>
                <mat-form-field dense appearance="outline" class="flex-[0_0_33%]">
                    <mat-label>Clave</mat-label>
                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                    <input name="password" formControlName="password" matInput type="password">
                </mat-form-field>
                <mat-form-field dense appearance="outline" class="flex-[0_0_33%]">
                    <mat-label>Confirmar clave</mat-label>
                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                    <input name="confirmP" formControlName="confirmP" matInput type="password">
                </mat-form-field>
            </div>

            <div class="flex flex-row gap-1 items-start">
                <mat-form-field dense appearance="outline" class="flex-[1_1_auto]">
                    <mat-label>Correo</mat-label>
                    <mat-icon matSuffix class="secondary-text">mail</mat-icon>
                    <input name="mail" formControlName="mail" type="mail" matInput>
                </mat-form-field>
                <mat-form-field dense appearance="outline" class="flex-[0_0_33%]">
                    <mat-label>Id. externo</mat-label>
                    <input name="externalId" formControlName="externalId" matInput>
                </mat-form-field>
            </div>

            <div class="flex flex-row gap-1 items-center justify-center">
                <mat-form-field dense appearance="outline" class="flex-[1_1_auto]">
                    <mat-label>Trabajo x Día</mat-label>
                    <mat-icon matSuffix class="secondary-text">timer</mat-icon>
                    <input name="workingHoursPerDay" formControlName="workingHoursPerDay" type="number" matInput>
                </mat-form-field>
                <div class="flex-[0_0_33%]" *ngIf="!(_systemService.visibility.seguimiento)">
                    <mat-form-field dense appearance="outline" class="flex-[1_1_auto]">
                        <mat-label>Valor Hora</mat-label>
                        <mat-icon matSuffix class="secondary-text">attach_money</mat-icon>
                        <input name="hourIncome" formControlName="hourIncome" matInput type="number">
                    </mat-form-field>
                </div>
                <div class="flex-[0_0_33%]" *ngIf="(_systemService.visibility.showRegisterAfterMonth)">
                    <mat-checkbox formControlName="enableRecordingHours">Habilitar registro HH</mat-checkbox>
                </div>
            </div>

            <div class="flex flex-row items-start">
                <mat-form-field dense appearance="outline" class="flex-grow">
                    <mat-label>Descripción</mat-label>
                    <textarea name="description" formControlName="description" matInput></textarea>
                </mat-form-field>
            </div>
            <div class="flex flex-row items-start" *ngIf="attributes && attributes.length > 0" >
                <!--                <div class="fuse-card m-4 p-8" fxFlex>-->

                <attributes #attributesComp [form]="contactForm" [values]="attributes" class="w-full" ></attributes>
                <!--                </div>-->
            </div>
            <!-- <div fxLayoutAlign="start start" class="w-100-p" > -->
            <div class="flex flex-col items-start w-full" >
                <h3>Roles:</h3>
            </div>
            <!-- <material-dual-listbox #dualList [source]="allPermissions" [(destination)]="role.permissions"></material-dual-listbox> -->
            <dual-list  [(destination)]="user.roles" [source]="roles" key="id"
                        display="name" [format]="format" height="200px" ></dual-list>
            <!-- </div> -->
            <!-- <div  fxLayoutAlign="start start" > -->
            <!-- <material-dual-listbox #dualList [source]="allPermissions" [(destination)]="role.permissions"></material-dual-listbox> -->
            <div class="flex flex-col items-start w-full" >
                <h3>{{ 'TEAM_LABEL_PLURAL' | translate }}:</h3>
            </div>
            <dual-list [source]="teams" [(destination)]="user.teams" key="id"
                       display="name" [format]="format" height="200px"></dual-list>
            <!-- </div> -->
        </form>
        <div *ngIf="_systemService.canAction('adminUsers')" class="flex flex-row items-center justify-end">

            <button *ngIf="action !== 'edit'"
                    mat-button mat-raised-button color="warn"
                    (click)="deleteUser()"
                    [disabled]="contactForm.invalid"
                    aria-label="DELETE">
                <!--                <mat-icon>delete</mat-icon>-->
                Borrar
            </button>
            <button *ngIf="action !== 'edit'"
                    mat-button mat-raised-button color="accent" class="save-button"
                    (click)="guardarUser()"
                    [disabled]="contactForm.invalid"
                    aria-label="SAVE">
                <!--                <mat-icon>save</mat-icon>-->
                Guardar
            </button>
        </div>
    </div>

    <div *ngIf="!user">
        <span>Debe seleccionar un usuario para modificar o presionar 'Nuevo' para crear un usuario nuevo</span>
    </div>
</div>
